// @flow

import { makeApiCall } from '../../../../services/apiService/apiService';

export const createQcTicketActions = {
  CREATE_QC_TICKET: 'CREATE_QC_TICKET'
};

export const createQcTicketAction = (obj: Object) => ({
  type: createQcTicketActions.CREATE_QC_TICKET,
  payload: obj
});

const defaultErrorMsg = 'Could not create Qc Ticket';

const createQcFailurePayload = (dispatch, res) => {
  dispatch(
    createQcTicketAction({
      fetched: true,
      fetching: false,
      data: null,
      error: (res && res.errorMessage) || defaultErrorMsg,
      boomerang: {
        component: 'toastr',
        type: 'error',
        removeExistingBms: true,
        heading: 'Error',
        message: (res && res.errorMessage) || defaultErrorMsg,
        timeOut: 3000
      }
    })
  );
};

export const createQcTicket = (cnoteDetails: Object) => (
  dispatch: Function
) => {
  dispatch(
    createQcTicketAction({
      fetching: true,
      fetched: false,
      data: null,
      boomerang: {
        component: 'toastr',
        type: 'fetching',
        removeExistingBms: true,
        heading: 'Please wait',
        message: 'Creating Qc ticket',
        timeOut: 0
      }
    })
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'createQcTicket',
    params: { cnote: cnoteDetails.cnote },
    method: 'POST',
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          createQcTicketAction({
            fetching: false,
            fetched: true,
            data: res.payload,
            boomerang: {
              component: 'toastr',
              type: 'success',
              removeExistingBms: true,
              heading: 'Success',
              message: 'Qc Ticket Created Successfully',
              timeOut: 3000
            }
          })
        );
      } else if (res.status === 'FAILURE') {
        createQcFailurePayload(dispatch, res);
      }
    },
    failureCb: res => {
      createQcFailurePayload(dispatch, res);
    },
    catchCb: res => {
      createQcFailurePayload(dispatch, res);
    }
  };
  return makeApiCall(requestObj);
};
